module.exports = __webpack_public_path__ + "img/vip3.897d9821.png";